import React, { useState } from 'react';
import { Dropdown, Grid, Icon, Input } from 'semantic-ui-react';
import { Slider } from "react-semantic-ui-range";

type SubtitleEditProps = {
  onChangeText: (newText: string) => void;
  onChangeLeft: (newLeft: number) => void;
  onChangeColor: (newColorCode: string) => void;
}
/**
 * 字幕情報編集コンポーネント
 */
function SubtitleEdit(props: SubtitleEditProps) {
  const options = [
    { key: 'white', text: '文字色: 白', value: '#ffffff' },
    { key: 'yellow', text: '文字色: 黄', value: '#fefe02' },
    { key: 'sky', text: '文字色: 水色', value: '#09fefe' },
    { key: 'green', text: '文字色: 緑', value: '#0dff09' },
    { key: 'red', text: '文字色: 赤', value: '#fc0a04' },
    { key: 'purple', text: '文字色: 紫', value: '#ff04ff' },
  ];

  /** 入力文字列 */
  const [text, setText] = useState('');

  const onChangeText = (newText: string) => {
    setText(newText);
    props.onChangeText(newText);
  }

  return (
    <>
      <Grid stackable columns={2}>
        <Grid.Column textAlign='left'>
          <h4>表示したい文字列</h4>
          <Input
            fluid
            placeholder='ここに入力...'
            label={
              <Dropdown
                defaultValue={options[0].value}
                options={options}
                onChange={(_, data) => { if (data.value !== undefined) props.onChangeColor(data.value.toString()) }} />
            }
            labelPosition='left'
            icon={
              <Icon
                link
                name='delete'
                onClick={() => onChangeText('')} />
            }
            value={text}
            onChange={(_, data) => { onChangeText(data.value) }} />
        </Grid.Column>
        <Grid.Column textAlign='left'>
          <h4>字幕の左位置</h4>
          <Slider
            discrete
            color='grey'
            settings={{
              min: 5,
              max: 95,
              step: 1,
              onChange: (val: number) => { props.onChangeLeft(val) }
            }} />
        </Grid.Column>
      </Grid>
    </>
  );
}

export default SubtitleEdit;